import { render, staticRenderFns } from "./MyDialogSmall.vue?vue&type=template&id=00553a0c&scoped=true"
import script from "./MyDialogSmall.vue?vue&type=script&lang=js"
export * from "./MyDialogSmall.vue?vue&type=script&lang=js"
import style0 from "./MyDialogSmall.vue?vue&type=style&index=0&id=00553a0c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00553a0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00553a0c')) {
      api.createRecord('00553a0c', component.options)
    } else {
      api.reload('00553a0c', component.options)
    }
    module.hot.accept("./MyDialogSmall.vue?vue&type=template&id=00553a0c&scoped=true", function () {
      api.rerender('00553a0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/control/components/MyDialogSmall.vue"
export default component.exports